export default __webpack_public_path__ + "static/media/hero_banner.a9188389.png";